import "../../styles/product-detail.css";
import Footer from "../../components/footer";
import Header from "../../components/header";

function EProcure() {
  return (
    <div>
      <Header />
      <div className="product-details">
        <div className="details-heading">
          <h1>e-Procure</h1>
          <p>
            Manage organizational spending through cost-effective procurement of
            goods & services.
          </p>
        </div>
        <div className="details-body">
          <p>
            <span>eProcure</span> is an integrated procurement system for
            supplier management, e-sourcing, and contract management . It give
            your procurement team the software tools for strategic sourcing to
            drive process efficiency and cost savings throughout the
            organization.
          </p>
          <p>
            <span>eProcure</span> is an easy-to-use, affordable, and
            customizable software solution used by large and small businesses
            and government procurement organizations for procurement and
            contract management.
          </p>
        </div>
        <div className="details-features">
          <p>
            <span>Benefits</span>
          </p>
          <ol>
            <li>
              <p>
                Centralize access to procurement data to promote informed
                decisions.
              </p>
            </li>
            <li>
              <p>
                Drive adoption of consistent procurement best practices across
                the organization.
              </p>
            </li>
            <li>
              <p>
                Ensure healthy supplier competition to meet quality and price
                objectives.
              </p>
            </li>
            <li>
              <p>Track spending and compliance with procurement policy.</p>
            </li>
            <li>
              <p>
                Capture of supplier diversity information to support business
                outreach programs.
              </p>
            </li>
            <li>
              <p>
                High-capacity messaging tools to broadcast business
                opportunities.
              </p>
            </li>
            <li>
              <p>
                Automated bidders list maintenance with optional public display.
              </p>
            </li>
            <li>
              <p>
                Pre-bid event management Sealed bidding using an “electronic
                lockbox”
              </p>
            </li>
            <li>
              <p>
                Auditable log of content changes, document views, and messages.
              </p>
            </li>
            <li>
              <p>Centralized management of supplier contracts.</p>
            </li>
            <li>
              <p>Simple, customizable self-service vendor registration.</p>
            </li>
            <li>
              <p>Robust bid document distribution features.</p>
            </li>
          </ol>
        </div>
        <div className="details-body">
          <p>
            eProcure is an end-to-end Software solution providing seamless
            integration into your existing corporate infrastructure and accounts
            systems. It incorporates a best of breed approach to systems design
            and functionality. It helps you better manage organizational
            spending through the efficient, cost-effective procurement of goods
            and services.
          </p>
          <p>
            eProcure allows end users to keep track of what stage their
            requisition has made it to without having to track down several
            individuals. This is a huge advantage for end users in saving time
            in creating and keeping track of their requisitions. Users can login
            to eProcure and navigate to the requisition status to verify and
            also approve/reject requisition(s).
          </p>
          <p>
            As an innovative solutions provider, we at Primose Technologies
            spend a great deal of time listening to purchasing professionals
            before arriving at ePocure; this has produced a range of fully
            flexible software that is sector independent, and has added immense
            value to our clients.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default EProcure;
